import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Input, Row, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';
import OldImageUploader from '../../../../firebase/OldImageUploader';
import { useTranslation } from 'react-i18next';

const General = ({ reportData, form, submit }) => {
  const { t } = useTranslation();
  const [mainColour, setMainColour] = useState(
    reportData && reportData.mainColour ? reportData.mainColour : '#ffffff',
  );

  const [aboutImage, setAboutImage] = useState([]);
  const [logoImage, setLogoImage] = useState([]);
  const [iconImage, setIconImage] = useState([]);

  useEffect(() => {
    if (reportData?.mainColour) {
      setMainColour(reportData.mainColour);
    }
    if (reportData?.aboutImage) {
      setAboutImage([reportData.aboutImage]);
    }
    if (reportData?.image) {
      setLogoImage([reportData.image]);
    }
    if (reportData?.icon) {
      setIconImage([reportData.icon]);
    }
  }, [reportData]);

  useEffect(() => {
    form.setFieldsValue({
      aboutImage: aboutImage,
    });
  }, [aboutImage])

  useEffect(() => {
    form.setFieldsValue({
      image: logoImage,
    });
  }, [logoImage]);

  useEffect(() => {
    form.setFieldsValue({
      icon: iconImage,
    });
  }, [iconImage]);

  const { getFieldDecorator } = form;

  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');

  return (
    <Row>
      <Col span={13}>
        <Row>
          <Col span={24}>
            <Card bordered={false}>
              <Form.Item label={t('appCms.appSettings.website')}>
                {getFieldDecorator('websiteLink', {
                  rules: [],
                  initialValue:
                    reportData && reportData.websiteLink
                      ? reportData.websiteLink
                      : undefined,
                })(<Input disabled={disable} />)}
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    {t('appCms.appSettings.mainColour')}&nbsp;
                    <Tooltip title={t('appCms.appSettings.mainColourTooltip')}>
                      <InfoCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator('mainColour', {
                  rules: [],
                  initialValue:
                    reportData && reportData.mainColour
                      ? reportData.mainColour
                      : undefined,
                })(
                  // <ColorPicker record={(reportData)? reportData.mainColour : undefined}  />
                  // <ColorPicker onChange={mainColourChange()} />
                  // <InputColour  color={reportData && reportData.mainColour}/>
                  <Input
                    disabled={disable}
                    onChange={e => setMainColour(e.target.value)}
                    suffix={
                      <>
                        {/* <Tooltip title="Enter Hex color code">
                            <InfoCircleOutlined />
                          </Tooltip> */}
                        <Button
                          style={{
                            background: mainColour,
                            marginLeft: '10px',
                          }}
                        >
                          {' '}
                        </Button>
                      </>
                    }
                  />,
                )}
              </Form.Item>


            </Card>
            <Card bordered={false} id="aboutImage">
              <Form.Item
                wrapperCol={{ xs: { span: 24 } }}
                style={{ display: 'flex', marginTop: '-25px' }}
              >
                {getFieldDecorator('aboutImage', {
                  valuePropName: 'file',
                })(
                  <Card
                    title={
                      <span>
                        {t('appCms.appSettings.aboutImage')}&nbsp;
                        <Tooltip title={t('appCms.appSettings.aboutImageTooltip')}>
                          <InfoCircleOutlined />
                        </Tooltip>
                      </span>
                    }
                  >
                    <Row justify="center">
                      <div className="clearfix">
                        <OldImageUploader
                          disabledAdd={!checkPermission(value, 'appcms', 'write')}
                          setFileList={setAboutImage}
                          fileList={aboutImage}
                          maxCount={1}
                          storageFolder='about-images'
                        />
                      </div>
                    </Row>
                  </Card>,
                )}
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col span={11}>
        <Card bordered={false}>
          <Form.Item
            wrapperCol={{ xs: { span: 24 } }}
            style={{ display: 'flex' }}
          >
            {getFieldDecorator('image', {
              valuePropName: 'file',
            })(
              <Card
                title={
                  <span>
                    {t('appCms.appSettings.logo')}&nbsp;
                    <Tooltip title={t('appCms.appSettings.logoTooltip')}>
                      <InfoCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                <Row justify="center">
                  <div className="clearfix">
                    <OldImageUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      setFileList={setLogoImage}
                      fileList={logoImage}
                      maxCount={1}
                      storageFolder='logo-images'
                    />
                  </div>
                </Row>
              </Card>,
            )}
          </Form.Item>
        </Card>
        <Card bordered={false}>
          <Form.Item
            wrapperCol={{ xs: { span: 24 } }}
            style={{ display: 'flex' }}
          >
            {getFieldDecorator('icon', {
              valuePropName: 'file',
            })(
              <Card
                title={
                  <span>
                    {t('appCms.appSettings.icon')}&nbsp;
                    <Tooltip title={t('appCms.appSettings.iconTooltip')}>
                      <InfoCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                <Row justify="center">
                  <div className="clearfix">
                    <OldImageUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      setFileList={setIconImage}
                      fileList={iconImage}
                      maxCount={1}
                      storageFolder='icon-images'
                    />
                  </div>
                </Row>
              </Card>,
            )}
          </Form.Item>
        </Card>
      </Col>
    </Row>
  );
};

General.propTypes = {
  form: PropTypes.object,
  reportData: PropTypes.object,
  submit: PropTypes.func,
};

General.contextType = UserContext;

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(General);
